<template>
  <div v-show="satisfied === false">
    <el-alert
        v-for="(error, index) in errors"
        :key="index"
        style="margin: 20px 0;"
        :title="title"
        type="info"
        show-icon>
      <ul class="shipping-eligibility-message-list">
        <li
            v-for="item in blacklist"
            :key="item ">
          {{ item }}
        </li>
      </ul>
    </el-alert>
  </div>
</template>

<script>
import axios from "axios";
import { uniq, keys } from "lodash";

export default {
  name: "ShippingEligibilityInfo",
  props: {
    title: {
      type: String,
      default: "Shipping not available for:",
    },
  },
  data() {
    return {
      blacklist: [],
      validating: false,
      satisfied: true,
      errors: [],
    };
  },
  methods: {
    display(products) {
      this.errors = [{}]; // to force iteration
      this.blacklist = products;
      this.satisfied = false;
    },
    evaluate(payload) {
      this.reset();
      let it = keys(payload).find((prop) => prop.match(/product_/))
        ? "product"
        : "parts";
      return new Promise((resolve, _reject) => {
        axios
          .post(`/v2/customer_requests/${it}_shipping_eligibility`, {
            request: payload,
          })
          .then((response) => {
            this.satisfied = response.data.satisfied;
            this.errors = response.data.errors;
            setTimeout(() => {
              this.validating = false;
            }, 5000);
            if (this.satisfied) resolve(true);
            else {
              let items = this.errors.reduce(
                (list, row) => list.concat(row.products),
                []
              );
              this.blacklist = uniq(this.blacklist.concat(items));
              resolve(false);
            }
          })
          .catch((_error) => {
            this.validating = false;
            this.$notify.warning({
              title: "Parts Shipping Eligibility",
              message: "Could not be determined.",
              duration: 5000,
            });
            resolve(false);
          });
      });
    },
    reset() {
      this.validating = true;
      this.satisfied = true;
      // this.blacklist;
      this.errors = [];
    },
  },
};
</script>

<style lang="scss" scoped>
ul.shipping-eligibility-message-list {
  padding-left: 0;
}
ul.shipping-eligibility-message-list li {
  display: block !important;
  margin: 3px 0 !important;
  min-width: available;
  min-width: -moz-available;
  float: none !important;
}
</style>
